import {combineReducers} from '@reduxjs/toolkit';
import identityVerificationParamSlice from './slices/identityVerificationParamSlice';
import paymenEventParamsSlice from './slices/paymenEventParamsSlice';
import guestAppEventParamsSlice from './slices/guestParamsEventsSlice';

const rootReducer = combineReducers({
  paymenEventParamsSlice,
  guestAppEventParamsSlice,
  identityVerificationParamSlice,
});

export type RootState = ReturnType<typeof rootReducer>;

export default rootReducer;
